<ng-container>
  <div
    appConfigSettingsParagraph
    class="sub-title"
  >
    {{ "KnowledgeTestEmailOfferForm.Title" | translate }}
  </div>
  <app-toggle-input
    class="full-width"
    appConfigSettingsInput
    placeholder="Insured.Gender"
    [form]="form"
    [optionsList]="genderList"
    [control]="form.get('customerGender')"
    [formSubmitted]="true"
  ></app-toggle-input>
  <app-text-input
    appConfigSettingsInput
    placeholder="KnowledgeTestEmailOfferForm.Name"
    [control]="form.get('customerName')"
    [form]="form"
  ></app-text-input>
  <app-text-input
    appConfigSettingsInput
    placeholder="KnowledgeTestEmailOfferForm.Email"
    [control]="form.get('customerEmail')"
    [form]="form"
    showPlaceholder="false"
    isRequiredMessageKey="Insured.EmailConfirmationIsRequiredMessage"
  ></app-text-input>
  <app-text-input
    class="full-width"
    appConfigSettingsInput
    placeholder="KnowledgeTestEmailOfferForm.Phone"
    [control]="form.get('customerPhone')"
    [form]="form"
    [pattern]="phonePattern"
    [inputMask]="phoneMask"
    showPlaceholder="false"
    prefix="+31 (0)"
    dropSpecialCharacters="true"
  ></app-text-input>
  <app-checkbox-input
    placeholder="KnowledgeTestEmailOfferForm.AgreeToShare"
    [form]="form"
    [control]="form.get('sendToIntermediary')"
    [isWeightNormalLabel]="true"
  ></app-checkbox-input>
  <div class="success-message" *ngIf="isSentSuccessfully">
    {{"KnowledgeTestEmailOfferForm.Success" | translate}}
  </div>
  <div class="buttons-control-container">
    <button
      type="button"
      appConfigSettingsPrimaryButton
      class="save-btn primary"
      color="primary"
      (click)="submitForm()"
      [disabled]="isSentSuccessfully"
    >
      {{ "KnowledgeTestEmailOfferForm.SendEmail" | translate }}
    </button>
  </div>
  <div class="notification-block">
    <app-notification-block
      [notification]="this.notificationEvent"
      appConfigSettingsParagraph
    ></app-notification-block>
  </div>
</ng-container>
